import { productUrlPrefix } from './url-utils';

export const gameDirectoryUrl = ({ product = 'waybetter' }) =>
  `${productUrlPrefix(product)}/games`;
